<template>
    <div class="section-box">
        <div class="customer-list">
            <el-row class="customer-row-bg">
                <el-col :span="12" style="text-align: left;display: flex;align-items: center;">
                    <el-form :inline="true" label-width="90px" label-position="left">
                        <el-form-item size="medium">
                            <el-button size="mini" :class="{'selected':form.status===''}" @click="handleSearchType()" style="margin-right: 15px;">全部</el-button>
                            <el-button size="mini" :class="{'selected':form.status===1}" @click="handleSearchType(1)" style="margin-right: 15px;">已发布</el-button>
                            <el-button size="mini" :class="{'selected':form.status===2}" @click="handleSearchType(2)" style="margin-right: 15px;">未发布</el-button>
                            <el-button size="mini" :class="{'selected':form.status===0}" @click="handleSearchType(0)" style="margin-right: 15px;">已删除</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
                <el-col :span="12" style="text-align: right">
                    <el-button size="medium" type="primary" icon="el-icon-plus" plain @click="linkListInfoFun(0)" v-if="!(typeof(actionData.originallist_add) != 'undefined'&&!actionData.originallist_add)">新建</el-button>
                    <el-button size="medium" type="primary" @click="handleSearch">查询</el-button>
                    <el-button size="medium" type="success" @click="handleReset">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <!-- 列表 -->
        <el-table
            ref="tableData"
            :stripe="true"
            :data="tableData"
            border
            style="width: 100%;margin-top: 20px;"
            height="640"
            v-loading="listLoading" 
            >
            <!-- eslint-disable  -->
            <el-table-column label="证书号">
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model.trim="form.id" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.id || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="原厂认证名称">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model.trim="form.authname" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.authname || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="品牌商">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-select 
                            size="mini" 
                            placeholder="请选择" 
                            v-model="form.brandId" 
                            style="width: 100%" 
                            filterable
                        >
                            <el-option 
                                v-for="(item, index) in brandArr" 
                                :value="item.key" 
                                :label="item.value"
                                :key="index">
                            </el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.brandName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="产品">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-select 
                            size="mini" 
                            placeholder="请选择" 
                            v-model="form.productId"
                            style="width: 100%" 
                            filterable
                        >
                            <el-option 
                                v-for="(item, index) in productSelectArr" 
                                :value="item.key" 
                                :label="item.value" 
                                :key="index"
                            >
                            </el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{ scope.row.productName || "--" }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="开始时间">
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-date-picker
                            size="mini"
                            v-model="form.startTime"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            range-separator="—"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 100%;"
                        ></el-date-picker>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.starttime || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="结束时间">
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-date-picker
                            size="mini"
                            v-model="form.endTime"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            range-separator="—"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 100%;"
                        ></el-date-picker>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.endtime || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="状态">
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model.trim="form.status" placeholder="请选择" style="width: 100%;">
                            <el-option 
                                v-for="(item, index) in statusArr" 
                                :key="index"
                                :value="item.JobStatus" 
                                :label="item.JobStatusTxt" 
                            >
                            </el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 1">已发布</span>
                        <span v-else-if="scope.row.status == 2">未发布</span>
                        <span v-else>已删除</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="操作" width="230" fixed="right">
                <template slot-scope="scope">
                    <template v-if="scope.row.status == 1">
                        <el-button size="mini" type="warning" @click="setConfigPublishOrDel(scope.row.id,2)">取消发布</el-button>
                    </template>
                    <template v-else-if="scope.row.status == 2">
                        <el-button size="mini" @click="linkListInfoFun(scope.row.id)">编辑</el-button>
                        <el-button size="mini" type="primary" @click="setConfigPublishOrDel(scope.row.id,1)">发布</el-button>
                        <el-button size="mini" type="danger" @click="setConfigPublishOrDel(scope.row.id,0)">删除</el-button>
                    </template>
                    <template v-else>
                        <el-button size="mini" @click="linkListInfoFun(scope.row.id)">编辑</el-button>
                        <el-button size="mini" type="success" v-if="isRestore" @click="setConfigPublishOrDel(scope.row.id,2)">恢复</el-button>
                    </template>
                </template>
            </el-table-column>
        </el-table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;" v-show="tableData.length">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="form.pageNum"
                    :page-sizes="[10, 20, 50, 100, 200]"
                    :page-size="form.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
    import {
        configList,     //国家认证列表
        configPublishOrDel, // 国家认证|原厂认证-发布|取消发布|删除
    } from "@/service/examination";
    import {
        dominList,
        productSelectList,
        brandList,
    } from "@/service/courseListApi";
    import { 
        getStorageUserRoleId,
        getActionData
    } from '@/utils/store'
    export default {
        data() {
            return {
                actionData: JSON.parse(getActionData()),      //功能按钮每个页面必须用
                listLoading: false,
                form: {
                    pageNum: 1,
                    pageSize: 10,
                    rational: true,
                    authtype: 2,        //1国家认证，2原厂认证

                    id: '',             //证书号
                    authname: '',       //证书名称
                    domainId: '',       //领域id
                    domainName: '',     //领域名称
                    brandId: '',        //品牌id
                    brandName: '',      //品牌名称
                    productId: '',      //产品id
                    productName: '',    //产品名称
                    exampapercount: '', //考试门数
                    status: '',         //状态 1. 已发布，2 未发布,0.已删除
                    startTime: [],      //开始时间
                    endTime: [],        //结束时间


                },
                
                searchData:{},
                oraginForm:{},
                total: 0,                       //总条数
                tableData:[],


                domainArr: [],                  //获取领域
                brandArr: [],                   //获取品牌
                productSelectArr: [],           //获取产品
                isRestore: false,               //是否显示恢复按钮
                statusArr:[                     //状态
                    {
                        JobStatus: 1,
                        JobStatusTxt: '已发布'
                    },
                    {
                        JobStatus: 2,
                        JobStatusTxt: '未发布'
                    },
                    {
                        JobStatus: 0,
                        JobStatusTxt: '已删除'
                    }
                ], 
            };
        },
        activated(){
            this.handleSearch()
        },
        created() {
            this.oraginForm = JSON.parse(JSON.stringify(this.form))
            this.tableData = [];
            this.handleSearch();
            this.getDominList();
            this.getBrandList();
            this.getProductSelectList();
        },
        methods: {
            // 获取领域
            getDominList() {
                dominList().then((r) => {
                    if (r.Result == 1) {
                        this.domainArr = r.Data || [];
                    }
                });
            },
            // 获取产品
            getProductAndList(id) {
                this.$nextTick(() => {
                    this.form.productId = ''
                    this.getProductSelectList(id);
                });
            },
            // 获取品牌
            getBrandList() {
                brandList().then((r) => {
                    if (r.Result == 1) {
                        this.brandArr = r.Data || [];
                    }
                });
            },
            getProductSelectList(id) {
                const _this = this;
                productSelectList(id).then((r) => {
                    _this.productSelectArr = r.Data || [];
                    _this.$forceUpdate();
                });
            },
            // 分类
            handleSearchType(type){
                if(type === 0) {
                    this.isRestore = true
                }else {
                    this.isRestore = false
                }
                this.form.status = type
                this.handleSearch()
            },
            // 查询
            handleSearch() {
                this.searchData = Object.assign({}, this.form)
                this.handleCurrentChange(1)
            },
            // 重置
            handleReset() {
                this.form = JSON.parse(JSON.stringify(this.oraginForm))
                this.handleSearch()
            },
            handleSizeChange(val) {
                if (this.listLoading) return
                this.form.pageNum = 1
                this.form.pageSize = val
                this.searchData.pageNum = 1
                this.searchData.pageSize = val
                this.GetCountriesListFun()
            },
            handleCurrentChange(val) {
                if (this.listLoading) return
                this.form.pageNum = val
                this.searchData.pageNum = val
                this.GetCountriesListFun()
            },
            //获取我的客户列表
            async GetCountriesListFun(){
                this.listLoading = true
                let data = JSON.parse(JSON.stringify(this.searchData))

                !data.id && delete data.id
                !data.authname && delete data.authname
                !data.domainId && delete data.domainId
                !data.domainName && delete data.domainName
                !data.brandId && delete data.brandId
                !data.brandName && delete data.brandName
                !data.productId && delete data.productId
                !data.productName && delete data.productName
                if(data.exampapercount === '') delete data.exampapercount
                if(data.status === '') delete data.status
                if (data.startTime instanceof Array && data.startTime.length) {
                    data.startTimeBegin = data.startTime[0] + " 00:00:00";
                    data.startTimeEnd = data.startTime[1] + " 23:59:59";
                }
                delete data.startTime;
                if (data.endTime instanceof Array && data.endTime.length) {
                    data.endTimeBegin = data.endTime[0] + " 00:00:00";
                    data.endTimeEnd = data.endTime[1] + " 23:59:59";
                }
                delete data.endTime;
                let res = await configList(data)
                this.listLoading = false
                if(res.Result != 1) {
                    return this.$message.error('获取失败请联系开发人员')
                }
                this.tableData = res.Data.datas
                this.total = res.Data.total
                this.$nextTick(()=>{
                    this.$refs.tableData.doLayout()
                })
            },
            // 跳转到客户信息
            linkListInfoFun(id) {
                this.$router.push('./originalDetail?id='+ id +'&authtype=2')
            },

            // 删除 发布 取消发布
            setConfigPublishOrDel(id,type){
                let data = {}
                data.id = id
                data.status = type
                configPublishOrDel(data).then(res=> {
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    this.$message.success('操作成功！')
                    this.GetCountriesListFun();
                })
            },
        }
    };
</script>
<style lang="scss">
    .customer-list {
        position: relative;
        .next-button {
            position: absolute;
            right: 0;
            top: -56px;
        }
    }
    .customer-row-bg {
        padding: 20px 14px;
        background-color: #f9fafc;
        display: flex;
        align-items: center;
        .el-form-item {
            margin-bottom: 0 !important;
        }
        .selected {
            color: #409EFF;
            border-color: #c6e2ff;
            background-color: #ecf5ff;
        }
    }
</style>